const tags = ['Products'];

export { tags };
